// src/services/api.js
import axios from 'axios';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const API = axios.create({
  // baseURL: 'http://localhost:5000/api',
  baseURL: BASE_URL+'/api',
});

API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default API;
